<template>
  <v-app>
    <div class="header--error d-flex align-center px-5" style="width: 100%">
      <img src="@/assets/it-logo.svg" style="max-width:150px; padding:10px;"/>
    </div>
    <v-main class="layout--error">
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'ErrorLayout'
}
</script>

<style scoped>
  .layout--error {
    background: url(../assets/full-page-bg.svg) center bottom/cover no-repeat;
  }

  .header--error {
    position: fixed;
  }
</style>
